/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ProfileImage/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import Avatar from 'DesignSystem/Avatar/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function ProfileImage({
  children,
  viewPath = "/App/Account/Search/Content/Profiles/Content/Profile/ProfileImage",
  presignedUrl
  
}) {
let personValueData = fromData.useDataFormat({ viewPath,
context: 'person',
format: fromFormat.initials,
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  presignedUrl
  
})
  return (<React.Fragment
>
<Avatar
  viewPath={`${viewPath}/Avatar`}
 marginTop={dtSpaceXs}
 onClick={onClick}
 profile_url={presignedUrl}
 data="person"
 format="/Data/format.js initials"
 initials={personValueData}
 size="large"
/>
{children}
</React.Fragment>)
}